import { BOX_SHADOWS, FONTS } from "../../constants";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { KeyboardArrowDown } from "@material-ui/icons";
import React from "react";
import { DATA_TYPES } from "../../constants";
import { stateType } from "../../state";
import { AreYouSurePopup } from "../Common/AreYourSurePopup";
import { trimString } from "../Common/helpers";
import { resetDashboard } from "../Common/resetDashboard";
import { HelpIcon } from "../Common/ToolTipIcon";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      backgroundColor: "white",
      boxShadow: BOX_SHADOWS,
      borderRadius: "10px",
      height: "340px",
    },
    root: {
      width: "100%",
    },
    paper: {
      width: "100%",
      marginBottom: theme.spacing(2),
    },
    table: {
      minWidth: 750,
    },
    visuallyHidden: {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      top: 20,
      width: 1,
    },
    trainButton: {},
    dropDown: {
      width: "140px",
      height: "30px",
      border: "solid",
      marginLeft: "20px",
      borderRadius: "5px",
      borderColor: "rgba(0,0,0,0.2)",
      borderWidth: "2px",
      marginTop: "-5px",
      display: "flex",
      flexDirection: "row",
      transition: "0.3s",
      cursor: "pointer",
      backgroundColor: "white",
      "&:hover": { backgroundColor: "rgba(0,0,0,0.1)" },
    },
  })
);

function DropDown({ state }: stateType) {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuSelect = (e) => {
    setAnchorEl(null);
    const columnName = e.target.id as string;
    if (columnName === state.saveState.modelTraining.valueToPredict) {
      return;
    }
    // state.setTempValueToPredict(columnName);
    localStorage.setItem("TempValueToPredict", columnName);
    if (state.saveState.savedModels.length > 0) {
      state.setIsResetDashOpen(true);
    } else {
      handleChangeValueToPredict();
    }
  };

  const handleChangeValueToPredict = () => {
    //Hackey :)
    const columnName = localStorage.getItem("TempValueToPredict");

    const col = state.saveState.dataset.getColumn(columnName);
    if (col !== undefined) {
      if (columnName !== state.saveState.modelTraining.valueToPredict) {
        state.saveState.modelTraining.valueToPredict = col.columnName;
        state.setSaveState(state.saveState, true);
        state.setCurrentModels(col.columnType);
        resetDashboard(state);
      }
    }
    state.setIsResetDashOpen(false);
  };

  let colNames: string[] = [];

  for (let col of state.saveState.dataset.columns) {
    if (
      col.columnType === DATA_TYPES.categorical &&
      col.nonSparseClasses.length > 1
    ) {
      colNames.push(col.columnName);
    } else if (col.columnType === DATA_TYPES.number) {
      colNames.push(col.columnName);
    }
  }
  colNames = colNames.sort((a, b) =>
    a.toLowerCase() < b.toLowerCase() ? -1 : 1
  );

  return (
    <div className={classes.dropDown}>
      <div
        onClick={(event: any) => handleClick(event)}
        style={{
          width: "100%",
          height: "100%",
          textAlign: "left",
          lineHeight: "30px",
          marginLeft: "10px",
        }}
      >
        {trimString(state.saveState.modelTraining.valueToPredict, 11)}
      </div>
      <KeyboardArrowDown
        style={{
          marginTop: "4px",
          width: "22px",
          height: "22px",
          left: "-4px",
        }}
      ></KeyboardArrowDown>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        style={{ marginTop: "43px", marginLeft: "-90px", maxWidth: "400px" }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        {colNames.map((colName) => (
          <MenuItem
            style={{ width: "190px" }}
            onClick={handleMenuSelect}
            id={colName}
          >
            {colName}
          </MenuItem>
        ))}
      </Menu>
      <AreYouSurePopup
        state={state}
        title="Reset Dashboard"
        message={"This will reset all your models, do you want to continue?"}
        handleCancel={() => state.setIsResetDashOpen(false)}
        handleContinue={handleChangeValueToPredict}
        isOpenTF={state.isResetDashOpen}
        continueLabel="Ok"
      ></AreYouSurePopup>
    </div>
  );
}

export function ValueDropDown({ state }: stateType) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        marginLeft: "20px",
      }}
    >
      <div style={{ fontFamily: FONTS, fontWeight: "bold" }}>
        {"Value to Predict"}
      </div>
      <div style={{ fontFamily: FONTS, fontWeight: "bold" }}>:</div>
      <div style={{ marginLeft: "-10px" }}>
        <DropDown state={state}></DropDown>
      </div>
      <HelpIcon
        title={
          "The value the Machine Learning models will be trained to predict."
        }
        marginLeft={"8px"}
      ></HelpIcon>
    </div>
  );
}
